import React, { useEffect, useState } from 'react'
import styled from '@emotion/styled'
import { fontSizeSmall, fontSizeXSmall, fontSize3XSmall, fontSize2XSmall, fontWeightBold, fontWeightRegular, grayLight20, grayLight30, fontFamilyOpenSans, grayDark40 } from '../../constants/principles'
import { useStateValue, useReRenderer, useScroller } from '../../hooks'
import useHealthCheck from '../../hooks/useHealthCheck'
import { ErrorUtils, BrowserUtils, StringUtils } from '../../utils/siteUtils'
import { BodyDivFlex } from '../generic/Basics'
import Error from '../generic/Error'
import ICOHeader from '../generic/ICOHeader'
import LegalText from '../landing/LegalText'
import NavFooter from '../generic/navFooter'
import PageHeader from '../generic/PageHeader'
import MaintenancePage from '../maintenance/Maintenance'
import ContactInfo from './ContactInfo'
import DealerRepInfo from './DealerRepInfo'
import Recaptcha from './Recaptcha'
import ReplacementInfo from './ReplacementInfo'
import ContactSubheader from './ContactSubheaderVariant'
import { SummaryPageNumber } from '../../constants'
import { ExteriorPageNumber } from '../../constants'
import { FlexDiv } from '../generic/Basics'
import ContactComponentWrapper from './ContactComponentWrapper'
import useEventBus from '../generic/useEventBus'
import useComponentFormValidation from '../generic/useComponentFormValidation'

export default ({
  experienceState,
  urlState,
  prospectDocuments,
  year,
  make,
  model,
  trim,
  color,
  transmission,
  engine,
  mileage,
  drivetrain,
  images,
  globalState,
  offerError,
  updateGlobalState,
  validateZip,
  validateUserInfo,
  verifyRecaptcha,
  getQuestionResponse,
  saveQuestionResponse,
  getQuestionResponseComment,
  setShowModal,
  dealerReps = [],
  nextClick,
  backClick,
  offer,
  zipInfo,
  variation,
  autoCheckData,
  vinResults,
  location,
  saveMultipleQuestionRaw,
  qxData
}) => {
  const {
    experience,
    isCobrand,
    cobrandingInfo,
    isAssigned,
    isAdmin,
    customerInfo,
    acceptsRV,
    isDigitalRetail,
    dealerInfo,
    displayImages,
    dealerName,
    isUIOffForDR,
    offerCode,
    lnxCode,
    dealerGuid,
    shouldShowOfferCreationComponent,
    includePixall,
    pixallId,
    pixallRealId,
    isIneligibleVehiclesEnabled,
    vehicleIntoAuction,
    customId,
    allowIneligibleVehicle,
    theme,
  } = experienceState

  const [isError, setError] = useStateValue(false)
  const [inValidCustomerCompomentForm, setInValidCustomerCompomentForm] = useStateValue(false)
  const isComponentCustomerContactValid = useComponentFormValidation('customer-contact')
  const [contactPageIsLoaded, setContactPageIsLoaded] = useState(false)
  const [reRender, random] = useReRenderer()
  const [setHasScrolled, scroll] = useScroller()
  const underMaintenance = useHealthCheck()
  const isDesktop = BrowserUtils.isDesktop()
  const isConsumerOffer = dealerInfo.isConsumerOffer || offer?.prospect?.isConsumerOffer
  const showContact = !isAdmin || isConsumerOffer
  const contactErrors = !showContact ? [] : isAdmin ? ['firstName', 'lastName', 'email', 'phone', 'zip'] : ['firstName', 'lastName', 'email', 'phone', 'zip', 'termsAccepted']
  const onEdit = isAdmin && urlState && urlState.pa && urlState.pa.includes('reviewoffer')
  const errors = []

  // component offer creation flag is on && ineligibleVehicles flag is on && components should show && isAssign offer flow && vehicle is ineligible
  const allowIneligibleVehicleForCobranding = allowIneligibleVehicle && isCobrand
  const allowIneligibleVehicles = isAssigned || allowIneligibleVehicleForCobranding
  const allowIneligibleVehiclesForWebComponent = isIneligibleVehiclesEnabled && shouldShowOfferCreationComponent && allowIneligibleVehicles && !vehicleIntoAuction
  // default Condition Page values
  updateGlobalState({ np: ExteriorPageNumber, cp: ExteriorPageNumber })
  const questionIdComment = 'qx/UserComments'
  const isVehicleGrounded = experienceState && experienceState.isVehicleGrounded
  const groundedVehicleComment = 'System: vehicle grounded by dealer.'
  // When removing additional comment, the urlState.dealerComment = ''
  const [localValueComment, setLocalValueComment] = useStateValue(urlState.dealerComment ?? offer?.prospect?.dealerComment ?? (isVehicleGrounded ? groundedVehicleComment : '') ?? '')
  const [renderSubmitHydrator, setRenderSubmitHydrator] = useState(false)
  const entry = globalState.entry
  // The dealership's dealerReps will not be retreived for an auction center so add assigned rep to array
  const dealerRepId = globalState.dealerRepId || (dealerInfo ? dealerInfo.dealerRepId || 0 : 0) || (offer && offer.prospect.dealerRepId)
  const dealerRepsList = dealerReps.length
    ? dealerReps
    : offer?.prospect
      ? [
          {
            dealerRepID: offer.prospect.dealerRepId,
            name: offer.prospect.dealerRepName,
            phone: offer.prospect.dealerRepPhone
          }
        ]
      : []
  let nextDisabled = false
  let contactErr = false

  for (var i in contactErrors) {
    if (!globalState[contactErrors[i]] || globalState[contactErrors[i] + 'Error']) {
      errors.push(contactErrors[i])
      contactErr = true
      nextDisabled = true
    }
  }

  if (onEdit && nextDisabled && !isError) {
    setError(true)
    reRender()
  }

  if (!isAdmin) {
    const leadType = getQuestionResponse('qrv/LeadType').v

    if (!leadType) {
      errors.push('leadType')
      nextDisabled = true
    } else if (leadType === 'OptIn') {
      const lookingForQuestions = ['qrv/LookingForNewCars', 'qrv/LookingForCertifiedCars', 'qrv/LookingForUsedCars']
      const ymmQuestions = ['qrv/YearRange', 'qrv/MakeModel1']
      let lf = false
      let ymm = true

      for (var x in lookingForQuestions) {
        lf = lf || getQuestionResponse(lookingForQuestions[x]).v === 0
      }

      if (!lf) {
        errors.push('lookingFor')
        nextDisabled = true
      }

      for (var y in ymmQuestions) {
        let answer = getQuestionResponseComment(ymmQuestions[y])
        ymm = ymm && answer && !answer.split(',').includes('NaN') && !answer.split(',').includes('undefined')
      }

      if (!ymm) {
        errors.push('ymm')
        nextDisabled = true
      }
    }

    if (!globalState.recaptchaVerified && !isAdmin) {
      errors.push('recaptchaVerified')
      nextDisabled = true
    }
  }

  if (isAdmin && (!globalState.origValuesContact || !globalState.origValuesContact.firstName) && globalState.firstName) {
    updateGlobalState({
      origValuesContact: {
        firstName: globalState.firstName,
        lastName: globalState.lastName,
        email: globalState.email,
        phone: globalState.phone,
        zip: globalState.zip,
        origValuesContact: undefined,
        firstNameError: globalState.firstNameError,
        lastNameError: globalState.lastNameError,
        emailError: globalState.emailError,
        phoneError: globalState.phoneError,
        zipError: globalState.zipError
      }
    })
  }

  if (isAdmin && (!globalState.origValuesDealerRep || !globalState.origValuesDealerRep.dealerRepId) && dealerRepId) {
    updateGlobalState({ origValuesDealerRep: { dealerRepId: dealerRepId, origValuesDealerRep: undefined } })
  }

  // urlState.p => current page, urlState.lp => furthest page user has landed on
  const currentPageVsFurthestPage = urlState.p !== urlState.lp
  let backDisabled = nextDisabled && currentPageVsFurthestPage

  if (shouldShowOfferCreationComponent) {
    if (showContact && currentPageVsFurthestPage && isComponentCustomerContactValid) {
      backDisabled = false
    }
  }
  const error = () => {
    setError(true)
    setHasScrolled(false)
    reRender()
    updateGlobalState({ fireAnalytics: 'continue_error' })
  }

  const assignComment = () => {
    urlState.dealerComment = localValueComment
    nextClick(SummaryPageNumber)
  }

  const getValueFromCustomerOrGlobal = param => {
    const contactInfo = offer?.prospect?.contactInfo || {}
    const value = (customerInfo && customerInfo[param]) || globalState[param] || contactInfo[param]

    if (value && param === 'phone') {
      return StringUtils.formatPhoneString(value)
    }
    return value || ''
  }

  const locationHref = qxData?.find(data => data.questionId === 'qx/IncomingURL').value ?? window.location.href
  const recaptchaDisabled = !!(globalState.environment && globalState.environment.recaptchaDisabled)
  const errorOffer = globalState.offerError?.errors || offerError
  const translateError = errorOffer ? ErrorUtils.translateError(errorOffer) : ''
  const emailCustomerCheckbox = experienceState.dealerInfo && experienceState.dealerInfo.sendEmail !== undefined ? 1 : 0
  const inviteId = experienceState.dealerInviteId

  const authToken = experienceState.authToken
  useEffect(() => {
    if (shouldShowOfferCreationComponent && errorOffer?.errors?.length > 0) {
      updateGlobalState({ fireAnalytics: 'asc_contact_error' })
    }
  }, [errorOffer])

  const showContactInfoWebComponent = () => {
    return (
      <ContactComponentWrapper
        contactPageIsLoaded={contactPageIsLoaded}
        updateGlobalState={updateGlobalState}
        year={year}
        make={make}
        model={model}
        trim={trim}
        color={color}
        transmission={transmission}
        engine={engine}
        drivetrain={drivetrain}
        vinResults={vinResults}
        mileage={mileage}
        firstName={getValueFromCustomerOrGlobal('firstName')}
        lastName={getValueFromCustomerOrGlobal('lastName')}
        email={getValueFromCustomerOrGlobal('email')}
        phone={getValueFromCustomerOrGlobal('phone')}
        zip={getValueFromCustomerOrGlobal('zip')}
        referrerUrl={locationHref}
        offerCode={offerCode}
        browserType={navigator.userAgent}
        lnxCode={lnxCode}
        entry={entry}
        dealerName={dealerName}
        showCustomerFormValidation={inValidCustomerCompomentForm}
        acceptsRv={acceptsRV && !isAdmin}
        isAssigned={isAssigned && isAssigned.length > 0}
        voiVin={location.initQueryParams.voivin}
        dealerGuid={dealerGuid}
        cobrandingInfo={cobrandingInfo}
        recaptchaDisabled={recaptchaDisabled}
        includePixall={includePixall}
        pixallId={pixallId}
        pixallRealId={pixallRealId}
        translateError={translateError}
        emailCustomerCheckbox={emailCustomerCheckbox}
        dealerRepId={dealerRepId}
        inviteId={inviteId}
        allowIneligibleVehicleSubmission={allowIneligibleVehiclesForWebComponent}
        isAdmin={isAdmin}
        showLegalAcceptance={!isAdmin}
        authToken={authToken}
        isConsumerOffer={!isAdmin || isConsumerOffer}
        showAdditionalComment={isAdmin}
        additionalComment={localValueComment}
        onCommentChange={setLocalValueComment}
        showLegalText={!isAdmin}
        customId={customId}
        theme={theme}></ContactComponentWrapper>
    )
  }

  useEffect(() => {
    if (shouldShowOfferCreationComponent) {
      nextDisabled = false
      BrowserUtils.addScript(globalState.environment.funnelWebComponentUrl, document.head, 'module', false)
      BrowserUtils.addScript('https://www.google.com/recaptcha/api.js?render=explicit', document.head)
    }
    setContactPageIsLoaded(true)
  })

  useEventBus('ReplacementVehicleInfoChanged', stateData => {
    if (!renderSubmitHydrator) {
      const questionIdArr = ['qrv/LeadType', 'qrv/LookingForNewCars', 'qrv/LookingForCertifiedCars', 'qrv/LookingForUsedCars', 'qrv/YearRange', 'qrv/MakeModel1', 'qrv/Make', 'qrv/Model']
      const answerIdArr = [
        { v: stateData.leadType },
        { v: +stateData.isLookingForNewCars },
        { v: +stateData.isLookingForCertifiedCars },
        { v: +stateData.isLookingForUsedCars },
        { c: stateData.yearRange.includes('null') ? undefined : stateData.yearRange },
        { c: stateData.selectedModel ? stateData.makeModelId : undefined },
        { c: stateData.selectedMake?.label },
        { c: stateData.selectedModel?.label }
      ]
      saveMultipleQuestionRaw(questionIdArr, answerIdArr, true)
    }
  })

  function getNextClick(e) {
    const { formCustomerValid } = globalState
    if (shouldShowOfferCreationComponent && formCustomerValid) {
      if (!formCustomerValid.isValid) {
        setInValidCustomerCompomentForm(true)
      } else {
        setRenderSubmitHydrator(true)
        nextClick(e)
      }
    } else {
      nextClick(e)
    }
  }

  const renderError = error => {
    return (
      <Error
        text={
          <>
            {ErrorUtils.translateError(error)
              .split('.')
              .slice(0, -1)
              .map(text => (
                <>
                  {text}
                  {'.'}
                  <br />
                </>
              ))}
          </>
        }
        isError={true}
        topError={true}
      />
    )
  }

  if (shouldShowOfferCreationComponent && showContact) {
    // This is Consumer created offer path w/ OfferCreationComponent flag on
    nextDisabled = !isComponentCustomerContactValid
  }

  return underMaintenance ? (
    <MaintenancePage />
  ) : (
    <>
      <BodyDivFlex isDesktop={isDesktop}>
        <ICOHeader {...{ displayImages, urlState, year, make, model, images, nextDisabled, errorFunc: error, updateGlobalState, variation, trim, autoCheckData, vinResults, experienceState, globalState, mileage }} />
        <PageHeader text={showContact ? 'Your Contact Information' : 'Dealer Rep Information'} useArgoStyle={shouldShowOfferCreationComponent} theme={theme}>
          {showContact && !shouldShowOfferCreationComponent && (
            <Subheader data-testid={`ci-txt-subheader`}>
              <ContactSubheader experienceState={experienceState} globalState={globalState} />
            </Subheader>
          )}
        </PageHeader>
        {!shouldShowOfferCreationComponent && errorOffer && renderError(errorOffer)}
        {isAdmin && (
          <DealerRepInfo
            disabled={!dealerReps.length ? true : dealerInfo && dealerInfo.dealerRepId}
            dealerReps={dealerRepsList}
            dealerRep={dealerRepsList.find(rep => +rep.dealerRepID === +dealerRepId)}
            updateGlobalState={updateGlobalState}
            isDesktop={isDesktop}
            useArgoStyle={shouldShowOfferCreationComponent}
          />
        )}
        {showContact && !shouldShowOfferCreationComponent && (
          <ContactInfo
            key={random}
            offerInfo={offer && offer.prospect.contactInfo}
            {...{ zipInfo, globalState, isDesktop, customerInfo, isCobrand, isAdmin, updateGlobalState, validateZip, validateUserInfo, setShowModal, isError, errors: contactErr ? errors : [], setHasScrolled, scroll, experience, isAssigned }}
          />
        )}
        {shouldShowOfferCreationComponent && showContactInfoWebComponent()}

        {isAdmin && !shouldShowOfferCreationComponent && (
          <ContentDiv>
            <SpacedDiv>
              <StyledH1>Additional Comments</StyledH1>
              <StyledH2>Please give us any additional information that might help us better evaluate this vehicle.</StyledH2>
              <StyleLabel htmlFor={questionIdComment}></StyleLabel>
              <StyledSpan>max 1000 characters</StyledSpan>
              <StyledTextArea name={questionIdComment} value={localValueComment} placeholder={'Comments'} rows={5} cols={40} maxLength={1000} onChange={e => setLocalValueComment(e.target.value)} />
            </SpacedDiv>
          </ContentDiv>
        )}

        {!shouldShowOfferCreationComponent && (
          <ReplacementInfo
            {...{
              prospectDocuments,
              setHasScrolled,
              scroll,
              isDigitalRetail,
              getQuestionResponse,
              saveQuestionResponse,
              getQuestionResponseComment,
              isError,
              contactErr,
              errors,
              cobrandingInfo,
              isDesktop,
              acceptsRV,
              isAdmin,
              optOutType: !!isAssigned ? 'OptOut' : 'CashOffer',
              isAssigned,
              dealerName,
              experienceState,
              saveMultipleQuestionRaw,
              updateGlobalState
            }}
          />
        )}

        {!isAdmin && !shouldShowOfferCreationComponent && (
          <RecaptchaDiv data-testid={`ci-recaptcha-iframe`}>
            <Recaptcha recaptchaSiteKey={globalState.environment.recaptchaSiteKey} {...{ verifyRecaptcha }} />
            {isError && errors.includes('recaptchaVerified') && <Error isError={isError} id={'recaptchaVerifiedError'} text={'Please verify that you are not a robot.'} />}
          </RecaptchaDiv>
        )}
        {!shouldShowOfferCreationComponent && offerCode && offerCode !== 'wc' && !isUIOffForDR && <LegalText isDesktop={isDesktop} dealerIsDirectToKBBv2={experienceState.dealerIsDirectToKBBv2} kbbUrl={globalState.environment.kbb_Url} />}
      </BodyDivFlex>
      {renderSubmitHydrator && <offer-submit-hydrator clear-state-on-failure={false} allow-ineligible-vehicle-submission={allowIneligibleVehiclesForWebComponent} />}

      <NavFooter
        {...{
          nextClick: (...e) => (nextDisabled ? error() : isAdmin ? assignComment() : getNextClick(...e)),
          backClick: (...e) => (backDisabled ? error() : backClick(ExteriorPageNumber)),
          experienceState,
          offer,
          globalState,
          updateGlobalState
        }}
        nextDisabled={showContactInfoWebComponent() && isAdmin ? nextDisabled : undefined}
        step={urlState.p}
        errors={errors}
        offerError={errorOffer}
      />
    </>
  )
}

const Subheader = styled.div`
  font-size: ${fontSize2XSmall};
  font-weight: normal;
  margin: 0px;
`

const RecaptchaDiv = styled.div`
  padding-top: 40px;
`

const SpacedDiv = styled(FlexDiv)`
  padding-bottom: 40px;
  margin-bottom: 40px;
  border-bottom: 1px solid ${grayLight30};
  &:last-child {
    margin-bottom: 0px;
    padding-bottom: 0px;
    border-style: none;
  }
`
const StyledH1 = styled.h1`
  font-size: ${p => (p.isDesktop ? fontSizeSmall : fontSizeXSmall)};
  font-weight: ${fontWeightBold};
  margin-top: 0px;
  margin-bottom: 0px;
`
const StyledH2 = styled.h2`
  font-size: ${fontSize2XSmall};
  font-weight: ${fontWeightRegular};
  margin: 12px 0;
  width: 100%;
`
const StyleLabel = styled.label`
  font-size: ${fontSize3XSmall};
  color: ${grayLight20};
`
const StyledSpan = styled.span`
  font-size: ${fontSize3XSmall};
  color: ${grayLight20};
  text-align: left;
  width: 80%;
`
const StyledTextArea = styled.textarea`
  font-family: ${fontFamilyOpenSans};
  width: 80%;
  margin-bottom: 24px;
`
const ContentDiv = styled(FlexDiv)`
  padding-top: 32px;
  padding-bottom: 32px;
  color: ${grayDark40};
  border-bottom: 1px solid ${grayLight20};
  width: ${p => (p.isDesktop ? 80 : 100)}%;
`
